import api from 'api'
import {
  CACHE_TAG_ACCOUNT_DETAILS_BY_ID,
  CACHE_TAG_ACCOUNTS_VERSION_LIST,
  CACHE_TAG_NOTIFICATION_LIST,
  CACHE_TAG_NOTIFICATION_UNREAD_COUNT,
} from 'api/cacheTagTypes'

import type { DeactivateAccountWithCaptureApi, DeactivationCaptureApi } from 'types/api/account/accountDeactivation'

type DeactivateWithCaptureArgs = DeactivationCaptureApi & { accountId: string; locations?: string[] }

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    requestAccountDeactivationWithCapture: build.mutation<DeactivateAccountWithCaptureApi, DeactivateWithCaptureArgs>({
      query: ({ accountId, locations = [], ...capture }) => ({
        url: `/api/v1/core/accounts/${accountId}/lifecycle/request-deactivate`,
        method: 'POST',
        body: { locations, ...capture },
      }),
      // A refused request changed nothing, so there is nothing to refetch.
      invalidatesTags: (result, error, { accountId }) =>
        error
          ? []
          : [
              { type: CACHE_TAG_ACCOUNTS_VERSION_LIST, id: accountId },
              { type: CACHE_TAG_ACCOUNT_DETAILS_BY_ID, id: accountId },
              CACHE_TAG_NOTIFICATION_LIST,
              CACHE_TAG_NOTIFICATION_UNREAD_COUNT,
            ],
    }),
    deactivateAccountWithCapture: build.mutation<void, DeactivateWithCaptureArgs>({
      query: ({ accountId, locations = [], ...capture }) => ({
        url: `/api/v1/core/accounts/${accountId}/lifecycle/deactivate`,
        method: 'POST',
        body: { locations, ...capture },
      }),
      invalidatesTags: (result, error, { accountId }) =>
        error
          ? []
          : [
              { type: CACHE_TAG_ACCOUNTS_VERSION_LIST, id: accountId },
              { type: CACHE_TAG_ACCOUNT_DETAILS_BY_ID, id: accountId },
            ],
    }),
  }),
})

export const { useRequestAccountDeactivationWithCaptureMutation, useDeactivateAccountWithCaptureMutation } = extendedApi
